class Converter {
  /**
   * Convert Object to JSON.
   *
   * @param {Object} object
   * @return {JSON}
   */
  public static toJson(object: Object): string {
    return JSON.stringify(object);
  }

  /**
   * Convert JSON to Object.
   *
   * @param {JSON} json
   * @return {Object}
   */
  public static toObject(json: string): Object {
    return JSON.parse(json);
  }
}

export default Converter;
